<template>
  <!-- 仪表权限配置 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="tableData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      v-model="tableForm"
      :permission="permissionList"
      :before-open="beforeOpenForm"
      :before-close="beforeCloseForm"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="loadData"
      @on-load="loadData"
    >
      <template slot="userIdListForm">
        <ChoicePeople :option="choicePeopleOption" @getPeople="getPeople" />
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import ChoicePeople from '@/components/choicePeopleOrDept/choicePeopleInput.vue';
import { mapGetters } from 'vuex';
import { getProjectList, getBizDict } from '@/api/meter-management/index';
import { getPageList, add, update, remove } from '@/api/meter-management/meter-permission';

export default {
  components: {
    ChoicePeople,
  },
  data() {
    return {
      projectList: [], // 项目列表
      searchForm: {}, // 搜索条件
      tableForm: {}, // crud表单
      choicePeopleOption: {
        projectId: '',
        variable: '',
        searchType: '',
        deptId: '',
        model: 'unlimitPeople', //singlePeople(单选人员)，people(选人 有限制加limit) unlimitPeople(无限制选人) dept(部门 有限制加上limit) singleDept unlimitDept(无限制选部门)
        selectList: [], //已选的集合
        prohibitList: [], //禁止选的集合
        limit: 1,
      },
      loading: false, // 是否正在加载表格数据
      tableData: [], // 表格数据
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格显示的配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        index: true,
        dialogClickModal: false,
        searchMenuSpan: 18,
        labelWidth: 120,
        menuWidth: 150,
        column: [
          {
            label: '项目名称',
            prop: 'projectId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
            type: 'select',
            hide: true,
            showColumn: false,
            display: false,
            search: true,
            searchClearable: false,
          },
          {
            label: '权限成员',
            prop: 'userIdList',
            formatter: (row) => {
              return row.userNames;
            },
            formslot: true,
            rules: [
              {
                required: true,
                message: '请选择权限成员',
                trigger: 'none',
              },
            ],
          },
          {
            label: '仪表管理区域',
            prop: 'areaCodeList',
            formatter: (row) => {
              return row.areaCodeNames;
            },
            type: 'tree',
            multiple: true,
            dicData: [],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请选择仪表管理区域',
                trigger: 'change',
              },
            ],
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.meter_permission_add, false),
        delBtn: this.vaildData(this.permission.meter_permission_del, false),
        editBtn: this.vaildData(this.permission.meter_permission_edit, false),
      };
    },
  },
  created() {
    getBizDict({ code: 'Imarea' }).then(({ data }) => {
      this.findObject(this.tableOption.column, 'areaCodeList').dicData = data;
    });
    getProjectList().then(({ data }) => {
      this.projectList = data || [];
      if (this.projectList.length > 0) {
        this.findObject(this.tableOption.column, 'projectId').dicData = this.projectList;
        this.searchForm.projectId = this.projectList[0].id;
        this.loadData();
      }
    });
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 336; // 表格区域初始化高度
      const searchH = 56; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    /* 加载表格数据 */
    loadData(page) {
      if (!this.searchForm.projectId) return;
      page = page || this.tablePage;
      this.loading = true;
      getPageList(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm)
      )
        .then(({ data }) => {
          this.tablePage.total = data.total;
          this.tableData = data.records;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    /* 重置搜索 */
    searchReset() {
      this.searchForm = {
        projectId: this.projectList[0].id,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.searchForm = params;
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    beforeOpenForm(done, type) {
      this.choicePeopleOption.projectId = this.searchForm.projectId;
      if (['add'].includes(type)) {
        this.choicePeopleOption.selectList = [];
        this.tableForm = {
          projectId: this.searchForm.projectId,
        };
      } else if (['edit', 'view'].includes(type)) {
        let names = this.tableForm.userNames.split(',');
        let ids = this.tableForm.userIdList;
        let arr = [];
        names.forEach((ele, index) => {
          arr.push({
            id: ids[index],
            realName: ele,
          });
        });
        this.choicePeopleOption.selectList = arr;
        this.tableForm.areaCodeList = this.tableForm.areaCodeList;
      }
      this.needCloseConfirm = true;
      done();
    },
    beforeCloseForm(done, type) {
      if (!this.needCloseConfirm) {
        done();
      } else {
        this.$confirm('确定关闭页面?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          done();
        });
      }
    },
    getPeople(obj) {
      let arr = [];
      obj.forEach((ele) => {
        arr.push(ele.id);
      });
      this.tableForm.userIdList = arr;
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.loadData();
          this.$message.success('操作成功!');
          this.needCloseConfirm = false;
          done();
        },
        () => {
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.loadData();
          this.$message.success('操作成功!');
          this.needCloseConfirm = false;
          done();
        },
        () => {
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({
            id: row.id,
          });
        })
        .then(() => {
          this.loadData();
          this.$message.success('操作成功!');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
